import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = {
    page: {
        height: '16px',
        width: '18px',
        'font-size': '13.82px',
        'font-weight': 'bold',
        'letter-spacing': '0.21px',
        'line-height': '16px',
        'text-align': 'center',
    },

    rectangle: {
        'box-sizing': 'border-box',
        height: '24.86px',
        width: '26.86px',
        border: '0.86px solid #E2E5E9',
        display: 'inline-block',
        'text-align': 'center',
    },

    rectangleSelected: {
        'box-sizing': 'border-box',
        height: '24.86px',
        width: '26.86px',
        border: '0.86px solid #E2E5E9',
        display: 'inline-block',
        'text-align': 'center',
        color: 'white',
        'background-color': '#1E91D0',
    },
};

const Item = ({ page, refine, onPaginationUpdate, classes, currentRefinement }) => {
    return (
        <a
            className={page === currentRefinement ? classes.rectangleSelected : classes.rectangle}
            href="#"
            onClick={(event) => onItemClick(event, page, refine, onPaginationUpdate)}
        >
            <span className={classes.page}>{page}</span>
        </a>
    );
};

const Arrow = ({ classes, refine, page, onPaginationUpdate }) => {
    return (
        <a
            className={classes.rectangle}
            href="#"
            onClick={(event) => onItemClick(event, page + 1, refine, onPaginationUpdate)}
        >
            <span className={classes.page}>></span>
        </a>
    );
};

const onItemClick = (event, page, refine, onPaginationUpdate) => {
    event.preventDefault();
    onPaginationUpdate(page);
    refine(page);
};

const Pagination = ({ currentRefinement, nbPages, refine, classes, onPaginationUpdate }) => {
    const pages = nbPages > 10 ? 10 : nbPages;
    return (
        <>
            {new Array(pages).fill(null).map((_, index) => {
                const page = index + 1;
                return (
                    <Item
                        key={index}
                        page={page}
                        refine={refine}
                        onPaginationUpdate={onPaginationUpdate}
                        classes={classes}
                        currentRefinement={currentRefinement}
                    />
                );
            })}

            {currentRefinement < pages && (
                <Arrow
                    classes={classes}
                    refine={refine}
                    page={currentRefinement}
                    onPaginationUpdate={onPaginationUpdate}
                />
            )}
        </>
    );
};

export default withStyles(styles)(Pagination);
